export const gaugeGroup = [
  {
    name: 'fontSize',
    labelId: 'FONT_SIZE',
    type: 'slider',
    default: 35,
    options: {
      min: 6,
      max: 200,
      step: 1,
    },
  },
];

// Extra Group
export const extraGroup = [
  {
    name: 'innerRadius',
    labelId: 'INNER_RADIUS',
    type: 'slider',
    default: 0.5,
    options: {
      min: 0,
      max: 0.8,
      step: 0.05,
    },
  },
  {
    name: 'borderWidth',
    labelId: 'BORDER_WIDTH',
    type: 'slider',
    default: 0,
    options: {
      min: 0,
      max: 10,
      step: 0.5,
    },
  },
  {
    name: 'margin.top',
    labelId: 'MARGIN_TOP',
    type: 'slider',
    default: 10,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.right',
    labelId: 'MARGIN_RIGHT',
    type: 'slider',
    default: 5,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.bottom',
    labelId: 'MARGIN_BOTTOM',
    type: 'slider',
    default: 0,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.left',
    labelId: 'MARGIN_LEFT',
    type: 'slider',
    forceUpdate: true,
    default: 5,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
];

export const controlsList = [
  ...gaugeGroup,
  ...extraGroup,
];
